// extracted by mini-css-extract-plugin
export default {"root":"a0zDni+3","text":"mcWHbFQT","controls":"zKyV29wF","actionButton":"xG0RMjCV","closeButton":"PsnKdfJC"};